module.exports = __webpack_public_path__ + "img/BOD-message-banner-responsive.376537dc.jpg";